import { axios } from '@Root/API'

export const get = (engagementId, leaverId) => {
	return axios.get(`student-engagement/${engagementId}/leaver/${leaverId}`)
}
